<div class="location-folder-contents">
  <div class="sidenav-toggle" fxLayout="row wrap" fxLayoutGap="5px">
    <div fxFlex="noshrink" class="expand-collapse-buttons">
      <evc-nav-button
        *ngIf="!isAllOpen()"
        [selected]="false"
        type="tertiary"
        size="sm"
        variant="square"
        leftIcon="plus"
        (click)="folderOpen(); $event.stopPropagation()"
      >
        {{ "locationFolderTab.expand" | translate }}
      </evc-nav-button>
      <evc-nav-button
        *ngIf="isAllOpen()"
        [selected]="false"
        type="tertiary"
        size="sm"
        variant="square"
        leftIcon="hyphen"
        (click)="folderClose(); $event.stopPropagation()"
      >
        {{ "locationFolderTab.collapse" | translate }}
      </evc-nav-button>
      <div fxFlex="noshrink"></div>
    </div>
  </div>
  <div class="batch-location" [style.height]="height + 'px'">
    <mat-tree [dataSource]="nestedDataSource" [treeControl]="nestedTreeControl" class="tree-content">
      <mat-tree-node *matTreeNodeDef="let subjectLocation" matTreeNodeToggle>
        <li
          fxFlex
          fxLayout="row"
          class="mat-tree-node folder-node"
          [class.drag-over]="isDragOverLocation === subjectLocation && isSelectedImage"
          [class.selectable]="isSelectedNested(subjectLocation)"
          [class.selected]="selectedLocation?.identifier === subjectLocation?.identifier"
          [style.padding-left]="getPaddingLeftValue(nestedDataSource.data, subjectLocation)"
          (click)="selectLocation(subjectLocation); $event.stopPropagation()"
          (dragover)="onDragOver($event, subjectLocation)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event, subjectLocation); $event.stopPropagation()"
        >
          <div>
            <mat-icon class="folder-icon" [class.operational]="subjectLocation.isOperational">folder</mat-icon>
          </div>
          <span class="folder-label" [matTooltip]="subjectLocation.name" [matTooltipPosition]="tooltipPosition" matTooltipClass="tooltip-overflow">
            {{ subjectLocation.name }}
          </span>
          <div fxFlex></div>
          <ng-container *ngIf="subjectLocation.identifier">
            <mat-menu #ImageMenu="matMenu">
              <button
                mat-menu-item
                (click)="imageLocationMultipleUpdate(subjectLocation)"
                [disabled]="!isSelectedImage || !canMoveImage(subjectLocation)"
              >
                {{ "locationFolderTab.moveHere" | translate }}
              </button>
              @if (canDisplayEditSectionSummaryButton) {
                <button mat-menu-item (click)="openSectionSummaryDialog(subjectLocation)" [disabled]="!inspection">
                  {{ "locationFolderTab.editSectionSummary" | translate }}
                </button>
              }

              @if (displayReportLocationCheckbox) {
                <mat-divider></mat-divider>
                <button mat-menu-item data-testid="add-media-to-report-button" (click)="selectLocation4Report(subjectLocation, $event)">
                  <div class="icon-with-text">
                    <evc-svg-icon
                      size="md"
                      [icon]="isSelectedLocationForReport(subjectLocation) ? checkedBox : uncheckedBox"
                      class="blue-icon"
                    ></evc-svg-icon>
                    {{ "locationFolderTab.addMediaToReport" | translate }}
                  </div>
                </button>
              }
            </mat-menu>
            @if (canDisplayEditSectionSummaryButton) {
              <button class="tree-button" mat-icon-button [matMenuTriggerFor]="ImageMenu" (click)="$event.stopPropagation()" data-testid="location-options-menu">
                <mat-icon class="open-list-item-menu">more_vert</mat-icon>
              </button>
            }
          </ng-container>
        </li>
      </mat-tree-node>

      <mat-nested-tree-node *matTreeNodeDef="let subjectLocation; when: hasNestedChild">
        <li (click)="callSelectLocation4FilterImages(subjectLocation); $event.stopPropagation()">
          <div
            class="mat-tree-node"
            [class.selectable]="isSelectedNested(subjectLocation)"
            [class.selected]="selectedParentNode(subjectLocation)"
            [style.padding-left]="getPaddingLeftValue(nestedDataSource.data, subjectLocation)"
          >
            <mat-icon class="arrow-icon" matTreeNodeToggle>
              {{ nestedTreeControl.isExpanded(subjectLocation) ? "expand_more" : "chevron_right" }}
            </mat-icon>
            <div>
              <mat-icon class="folder-icon" [class.operational]="subjectLocation.isOperational">folder</mat-icon>
            </div>
            <span class="folder-label" [matTooltip]="subjectLocation.name" [matTooltipPosition]="tooltipPosition" matTooltipClass="tooltip-overflow">
              {{ subjectLocation.name }}
            </span>
          </div>
          <ul [class.tree-invisible]="!nestedTreeControl.isExpanded(subjectLocation)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </li>
      </mat-nested-tree-node>
    </mat-tree>
  </div>
</div>
